function updateGoogleConsent(cookieconsent) {
    if (typeof gtag !== 'function') {
        return;
    }

    var analyticsGranted = cookieconsent.allowedCategory('analytics');
    var trackingGranted = cookieconsent.allowedCategory('tracking');

    gtag('consent', 'update', {
        'analytics_storage': analyticsGranted ? 'granted' : 'denied',
        'ad_storage': trackingGranted ? 'granted' : 'denied',
        'ad_user_data': trackingGranted ? 'granted' : 'denied',
        'ad_personalization': trackingGranted ? 'granted' : 'denied'
    });
}

window.addEventListener('load', function () {
    console.log("jazyk: "+document.documentElement.getAttribute('lang'));
    var cookieconsent = initCookieConsent();
    cookieconsent.run({
        current_lang : document.documentElement.getAttribute('lang'),
        page_scripts: true,

        autorun : true,
        delay : 0,
        autoclear_cookies : true,

        theme_css : '/css/cookieConsent.css',

        gui_options: {
            consent_modal : {
                layout : 'cloud',               // box/cloud/bar
                position : 'bottom center',     // bottom/top + left/right/center
                transition: 'slide'             // zoom/slide
            },
            settings_modal : {
                layout : 'box',                 // box/bar
                transition: 'slide',            // zoom/slide
            }
        },

        onAccept: function(cookies){
            updateGoogleConsent(cookieconsent);

            if(cookieconsent.allowedCategory('necessary')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event:"CookieConsent",
                    consentType:"necessary"
                });
            }


            if(cookieconsent.allowedCategory('analytics')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event:"CookieConsent",
                    consentType:"analytics"
                });
            }

            if(cookieconsent.allowedCategory('tracking')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event:"CookieConsent",
                    consentType:"tracking"
                });
            }


        },

        onChange: function(cookies){
            updateGoogleConsent(cookieconsent);
        },

        languages : {
            'en' : {
                consent_modal : {
                    title :  "Cookies information",
                    description :  'By clicking on "Accept all cookies", you agree to storage cookies on your device, which helps with site navigation, data usage analysis and our marketing efforts.',
                    primary_btn: {
                        text: 'Accept All Cookies',
                        role: 'accept_all'  //'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text : 'Cookies Prefences',
                        role : 'settings'   //'settings' or 'accept_necessary'
                    }
                },
                settings_modal : {
                    title : 'Cookies settings',
                    save_settings_btn : "Save preferences",
                    accept_all_btn : "Accept All",
                    close_btn_label: "Close",
                    cookie_table_headers : [
                        {col1: "Cookie" },
                        {col2: "Description" },


                    ],
                    blocks : [
                        {
                            title : "We use Cookies",
                            description: 'We use cookies for analysis of our visitor data, to improve our website, show personalized content and to give you a great website experience. By using this website, you consent to this use.',
                        },{
                            title : "Functional Cookies",
                            description: 'These cookies are necessary for the Website to work, so it is not possible to disable them. They are usually set up in response to an action you take on the Website yourself, such as security settings, logging in, and filling out forms. You can set your browser to block cookies or send notifications about them. Keep in mind that some pages will not work without these files. These cookies do not store any information that can be assigned to a specific person. These cookies may be set by us or by third party providers whose services we use on the website. These cookies do not store any information that can be assigned to a specific person.',
                            toggle : {
                                value : 'necessary',
                                enabled : true,
                                readonly: true
                            },
                        },{
                            title : "Analytics Cookies",
                            description: 'These cookies are used to improve the functioning of the Website. They allow us to recognize and track the number of visitors and track how visitors use the Website. They help us improve the way the Website works, for example, by allowing users to easily find what they are looking for. These cookies do not collect information that could identify you. Using these tools, we analyze and regularly improve the functionality of our Website. We can use the obtained statistics to improve user comfort and to make your visit to the Website more interesting for you as a user.',
                            toggle : {
                                value : 'analytics',
                                enabled : false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'Google Analytics',
                                    col2: 'Stores and counts the number of page views and site behaviour',
                                },
                                {
                                    col1: 'Google Tag Manager',
                                    col2: 'Link conversions',
                                }
                            ]
                        }
                    ]
                }
            },
            'cs' : {
                consent_modal : {
                    title :  "Informace o cookies",
                    description :  'Kliknutím na Souhlasím se vším budou uloženy cookies funkční, výkonnostní, analytické i marketingové - dokážeme vám tak umožnit pohodlné používání webu, měřit funkčnost našeho webu i vás cílit reklamou. Své preference můžete snadno upravit kliknutím na Nastavení cookies.',
                    primary_btn: {
                        text: 'Souhlasím se vším',
                        role: 'accept_all'  //'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text : 'Nastavení cookies',
                        role : 'settings'   //'settings' or 'accept_necessary'
                    }
                },
                settings_modal : {
                    title : 'Nastavení cookies',
                    save_settings_btn : "Uložit nastavení",
                    accept_all_btn : "Souhlasím se vším",
                    close_btn_label: "Zavřít",
                    cookie_table_headers : [
                        {col1: "Cookie" },
                        {col2: "Popis" },


                    ],
                    blocks : [
                        {
                            title : "Používáme cookies",
                            description: 'Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu. Používáním tohoto webu s tímto používáním souhlasíte.',
                        },{
                            title : "Funkční Cookies",
                            description: 'Tyto soubory cookie jsou nezbytné pro fungování webových stránek, není tedy možné je zakázat. Obvykle se nastavují v reakci na akci, kterou na webu sami provedete, jako je nastavení zabezpečení, přihlášení a vyplňování formulářů. Svůj prohlížeč můžete nastavit tak, aby blokoval soubory cookie nebo o nich zasílal upozornění. Mějte na paměti, že některé stránky nebudou bez těchto souborů fungovat. Tyto soubory cookie neukládají žádné informace, které lze přiřadit konkrétní osobě. Tyto soubory cookie můžeme nastavit my nebo poskytovatelé třetích stran, jejichž služby na webu využíváme. Tyto soubory cookie neukládají žádné informace, které lze přiřadit konkrétní osobě.',
                            toggle : {
                                value : 'necessary',
                                enabled : true,
                                readonly: true
                            },
                        },{
                            title : "Analytické Cookies",
                            description: 'Tyto soubory cookie se používají ke zlepšení fungování webových stránek. Umožňují nám rozpoznat a sledovat počet návštěvníků a sledovat, jak návštěvníci web používají. Pomáhají nám zlepšovat způsob, jakým webové stránky fungují, například tím, že uživatelům umožňují snadno najít to, co hledají. Tyto soubory cookie neshromažďují informace, které by vás mohly identifikovat. Pomocí těchto nástrojů analyzujeme a pravidelně zlepšujeme funkčnost našich webových stránek. Získané statistiky můžeme využít ke zlepšení uživatelského komfortu a k tomu, aby byla návštěva Webu pro vás jako uživatele zajímavější.',
                            toggle : {
                                value : 'analytics',
                                enabled : false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'Google Analytics',
                                    col2: 'Ukládá a počítá počet zobrazení stránek a chování webu',
                                },
                                {
                                    col1: 'Google Tag Manager',
                                    col2: 'Propojení konverzí',
                                }
                            ]
                        }
                    ]
                }
            },
            'sk' : {
                consent_modal : {
                    title :  "Informácie o cookies",
                    description :  'Kliknutím na Súhlasím so všetkým sa uložia funkčné, výkonnostné, analytické a marketingové cookies, aby sme vám umožnili pohodlné používanie stránky, meranie funkčnosti našej stránky a cielenie reklamy. Svoje nastavenia môžete ľahko upraviť kliknutím na Nastavenia cookies.',
                    primary_btn: {
                        text: 'Súhlasím so všetkým',
                        role: 'accept_all'  //'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text : 'Nastavenia cookies',
                        role : 'settings'   //'settings' or 'accept_necessary'
                    }
                },
                settings_modal : {
                    title : 'Nastavenia cookies',
                    save_settings_btn : "Uložiť nastavenia",
                    accept_all_btn : "Súhlasím so všetkým",
                    close_btn_label: "Zatvoriť",
                    cookie_table_headers : [
                        {col1: "Cookie" },
                        {col2: "Popis" },


                    ],
                    blocks : [
                        {
                            title : "Používame cookies",
                            description: 'Súbory cookie používame na analýzu údajov o našich návštevníkoch, na zlepšovanie našich webových stránok, na zobrazovanie personalizovaného obsahu a na to, aby sme vám poskytli skvelé webové prostredie. Používaním tejto webovej stránky vyjadrujete súhlas s týmto používaním.',
                        },{
                            title : "Funkčné Cookies",
                            description: 'Tieto súbory cookie sú nevyhnutné na fungovanie webovej stránky a nemožno ich vypnúť. Zvyčajne sa nastavujú ako reakcia na akciu, ktorú vykonáte na webovej lokalite, napríklad nastavenie zabezpečenia, prihlásenie a vyplnenie formulárov. Prehliadač môžete nastaviť tak, aby blokoval súbory cookie alebo zasielal upozornenia na ne. Majte na pamäti, že niektoré stránky nebudú bez týchto súborov fungovať. Tieto súbory cookie neukladajú žiadne informácie, ktoré by sa dali priradiť ku konkrétnej osobe. Tieto súbory cookie môžeme nastaviť my alebo poskytovatelia tretích strán, ktorých služby na stránke využívame. Tieto súbory cookie neukladajú žiadne informácie, ktoré by sa dali priradiť ku konkrétnej osobe.',
                            toggle : {
                                value : 'necessary',
                                enabled : true,
                                readonly: true
                            },
                        },{
                            title : "Analytická Cookies",
                            description: 'Tieto súbory cookie sa používajú na zlepšenie fungovania webovej stránky. Umožňujú nám rozpoznať a sledovať počet návštevníkov a monitorovať, ako návštevníci používajú webové stránky. Pomáhajú nám zlepšovať fungovanie webovej stránky, napríklad tým, že umožňujú používateľom ľahko nájsť to, čo hľadajú. Tieto súbory cookie nezhromažďujú informácie, ktoré by vás mohli identifikovať. Tieto nástroje používame na analýzu a pravidelné zlepšovanie funkčnosti našich webových stránok. Zhromaždené štatistiky môžeme použiť na zlepšenie používateľského zážitku a na to, aby bola vaša návšteva stránky pre vás ako používateľa zaujímavejšia.',
                            toggle : {
                                value : 'analytics',
                                enabled : false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'Google Analytics',
                                    col2: 'Ukladá a počíta počet zobrazení stránok a správanie webu',
                                },
                                {
                                    col1: 'Google Tag Manager',
                                    col2: 'Prepojenie konverzií',
                                }
                            ]
                        }
                    ]
                }
            },
            'pl' : {
                consent_modal : {
                    title :  "Informacje o plikach cookie",
                    description :  'Klikając „Akceptuj wszystkie”, zgadzasz się na przechowywanie plików cookie na Twoim urządzeniu, co pomaga w nawigacji w witrynie, analizie wykorzystania danych i naszych działaniach marketingowych.',
                    primary_btn: {
                        text: 'Akceptuj wszystkie',
                        role: 'accept_all'  //'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text : 'Preferencje',
                        role : 'settings'   //'settings' or 'accept_necessary'
                    }
                },
                settings_modal : {
                    title : 'Ustawienia plików cookie',
                    save_settings_btn : "Zapisz preferencje",
                    accept_all_btn : "Akceptuj wszystkie",
                        close_btn_label: "Zamknij",
                    cookie_table_headers : [
                        {col1: "Cookie" },
                        {col2: "Opis" },


                    ],
                    blocks : [
                        {
                            title : "Używamy plików Cookies",
                            description: 'Używamy plików cookie do analizy danych dotyczących odwiedzających, do ulepszania naszej strony internetowej, wyświetlania spersonalizowanych treści i zapewnienia Ci doskonałej obsługi strony. Korzystając z tej strony internetowej, wyrażają Państwo zgodę na to wykorzystanie.',
                        },{
                            title : "Funkcjonalne cookies",
                            description: 'Te pliki cookie są niezbędne do działania Witryny, dlatego nie ma możliwości ich wyłączenia. Zazwyczaj są one ustawiane w odpowiedzi na działania podejmowane przez użytkownika w Witrynie, takie jak ustawienia bezpieczeństwa, logowanie i wypełnianie formularzy. Możesz ustawić swoją przeglądarkę tak, aby blokowała pliki cookie lub wysyłała powiadomienia o nich. Należy pamiętać, że niektóre strony nie będą działać bez tych plików. Te pliki cookie nie przechowują żadnych informacji, które można przypisać do konkretnej osoby. Te pliki cookie mogą być ustawiane przez nas lub przez zewnętrznych dostawców, z których usług korzystamy na stronie internetowej. Te pliki cookie nie przechowują żadnych informacji, które mogą być przypisane do konkretnej osoby.',
                            toggle : {
                                value : 'necessary',
                                enabled : true,
                                readonly: true
                            },
                        },{
                            title : "Analityczne cookies",
                            description: 'Te pliki cookie są wykorzystywane do poprawy funkcjonowania Witryny. Pozwalają nam rozpoznać i śledzić liczbę odwiedzających oraz sposób, w jaki odwiedzający korzystają z Witryny. Pomagają nam usprawnić działanie Witryny, na przykład poprzez umożliwienie użytkownikom łatwego znalezienia tego, czego szukają. Te pliki cookie nie zbierają informacji, które mogłyby zidentyfikować użytkownika. Korzystając z tych narzędzi, analizujemy i regularnie poprawiamy funkcjonalność naszej Strony. Uzyskane dane statystyczne możemy wykorzystać do poprawy komfortu korzystania z Witryny i uczynienia jej odwiedzin bardziej interesującymi dla użytkownika.',
                            toggle : {
                                value : 'analytics',
                                enabled : false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'Google Analytics',
                                    col2: 'Przechowuje i zlicza liczbę odsłon i zachowań na stronie.',
                                },
                                {
                                    col1: 'Google Tag Manager',
                                    col2: 'Konwersje linków',
                                }
                            ]
                        }
                    ]
                }
            },

        }
    });

    if(!cookieconsent.validCookie('cc_cookie')){
        var dataLayer = window.dataLayer || [];
        dataLayer.push({
            event:"CookieConsent",
            consentType:"empty"
        });


    }
});
